export default "__VITE_ASSET__BKReZhlj__"